// extracted by mini-css-extract-plugin
module.exports = {"container":"_1SvGF","banner":"jvWwD","title":"pr-A5","subTitle":"_3-UhV","text1":"_2ildD","text2":"_264K-","learnButton":"_2Tk74","bannerBg":"AsA-L","bg1":"SJMgE"};